/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { ratingCategoryDtoSchema } from "./ratingCategoryDtoSchema.ts";
import { z } from "zod/v4";

export const ratingDtoSchema = z.object({
  authorName: z.optional(z.string()),
  authorInitials: z.optional(z.string()),
  mode: z.optional(z.enum(["Simplified", "Advanced"]).default("Simplified")),
  score: z.int().nullish(),
  comment: z.string().nullish(),
  get categories() {
    return z.array(ratingCategoryDtoSchema).optional();
  },
  updatedAt: z.optional(z.iso.datetime()),
  isCurrentUser: z.optional(z.boolean()),
});
